var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	53858: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(78281))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	93888: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(8568))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	39817: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(28477))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	8378: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(65499))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.13.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",

	},
	10742: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(13134))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "jwt-decode",

	},
	5839: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(78041))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.39.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-query",

	},
	12794: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(83598))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^11.18.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	14234: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(57310))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "setimmediate",

	},
	14911: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(65271))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^21.9.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	51253: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(93805))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.4.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	62783: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(37867))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.1.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-web-core-sdk",

	},
	99141: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(36339))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.19.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-web-tw-component",

	},
	99945: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(93033))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.539.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lucide-react",

	},
	14275: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(18496))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^6.7.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@casl/ability",

	},
	16346: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(226)]).then(() => (() => (__webpack_require__(28724))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "3.1.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-eventbus-sdk",

	},
	44968: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(73203))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^5.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@casl/react",

	},
	91136: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(43979))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^15.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "prop-types",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"119": [
		8378,
		10742
	],
	"136": [
		91136
	],
	"517": [
		14275,
		16346,
		44968
	],
	"817": [
		39817
	],
	"858": [
		53858
	],
	"866": [
		5839,
		12794,
		14234,
		14911,
		51253,
		62783,
		99141,
		99945
	],
	"888": [
		93888
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}